import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = {
  "clip-path": "url(#clip0_5186_60381)"
};
const _hoisted_3 = ["stroke"];
const _hoisted_4 = ["stroke"];
const _hoisted_5 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_5186_60381"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24",
  fill: "white"
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    width: $props.width,
    height: _ctx.heigth,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M23 23L18.9168 18.9167M21.8333 11.9167C21.8333 17.3935 17.3935 21.8333 11.9167 21.8333C6.43984 21.8333 2 17.3935 2 11.9167C2 6.43984 6.43984 2 11.9167 2C17.3935 2 21.8333 6.43984 21.8333 11.9167Z",
    stroke: $props.color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_3), _createElementVNode("path", {
    d: "M12 8L12 12M12 16L11.99 16M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
    stroke: $props.color,
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_4)]), _hoisted_5], 8, _hoisted_1);
}